import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Row,
  Form,
} from "reactstrap"
import Rating from "components/Rating"
import * as Yup from "yup"
import { useFormik } from "formik"
import FormLabel from "components/Extra/FormLabel"
import { useTranslation } from "react-i18next"

const data = {
  id: "ID-12345678",
  name: "Delivery Man Name",
  rate: 4,
  img: "https://img.freepik.com/free-photo/delivery-man-pointing-front_1368-204.jpg?semt=ais_hybrid&w=740",
  dateOfHire: "25 dec, 2022",
  places: ["Doha", "Al-Rayan", "Al-Khor", "Al-Shatt"],
  status: true,
  description:
    "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  mobileNumber: "+97856412387",
  address: "Doha, Qatar",
}

const DeliveryManDetails = () => {
  const { t } = useTranslation()

  const [copied, setCopied] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    initialValues: {
      mobileNumber: data.mobileNumber || "",
      address: data.address || "",
      rate: data.rate || 1,
      active: data.status,
    },
    validationSchema: Yup.object({
      mobileNumber: Yup.string()
        .trim()
        .required(t("deliveryMen_mobileNumberValidationMessage") as string),
      address: Yup.string()
        .trim()
        .required(t("deliveryMen_addressValidationMessage") as string),
      rate: Yup.number().required(
        t("deliveryMen_rateValidationMessage") as string
      ),
      active: Yup.boolean(),
    }),
    onSubmit: values => {
      const { active, address, mobileNumber, rate } = values
      console.log(values)

      // TODO: Dispatch
      validation.resetForm()
    },
  })

  const handleRatingChange = (rating: number) => {
    console.log("Selected rating:", rating)
    validation.setFieldValue("rate", rating)
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500) // يختفي بعد 1.5 ثانية
    })
  }
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard") as string}
          breadcrumbItem={t("deliveryMen_deliveryMen")}
          subBreadcrumbItem={t("deliveryMen_deliveryManName")}
        />
        <div className="d-flex gap-2">
          {!isEdit ? (
            <Button
              onClick={() => {
                setIsEdit(true)
              }}
              className="bg-gradiant-blue border-0 text-capitalize"
            >
              {t("deliveryMen_editInfo")}
            </Button>
          ) : (
            <Button
              onClick={() => {
                validation.handleSubmit()
                setIsEdit(false)
              }}
              className="bg-transparent border border-success text-success text-capitalize"
            >
              {t("deliveryMen_saveInfo")}
            </Button>
          )}
          <Button
            onClick={() => {}}
            className="bg-transparent border text-danger border-danger text-capitalize"
          >
            {t("deliveryMen_deleteDelivery")}
          </Button>
        </div>
      </div>
      <Card className="shadow-md rounded-3">
        <CardBody>
          <Row>
            <Col xl={4}>
              <div className="product-detai-imgs">
                <div className="rounded-3 border overflow-hidden shadow">
                  <img
                    src={data.img}
                    alt=""
                    id="expandedImg1"
                    className="img-fluid mx-auto d-block"
                    style={{ maxWidth: "300px" }}
                  />
                </div>
              </div>
            </Col>

            <Col xl="8">
              <div className="d-flex justify-content-between">
                <h4 className="text-semi-dark fw-semibold m-0">{data.name}</h4>
                <p className="text-semi-dark fw-semibold font-size-16">
                  <Rating
                    totalStars={5}
                    initialValue={data.rate}
                    onChange={handleRatingChange}
                    isDisabled={!isEdit}
                  />
                </p>
              </div>

              <div className="d-flex gap-2 mb-4">
                {data.places &&
                  data.places.map((address, index) => (
                    <span
                      key={index}
                      className="badge bg-primary-30 text-primary font-size-12 p-2 fw-semibold"
                    >
                      {address}
                    </span>
                  ))}
              </div>

              <div className="d-flex justify-content-between mb-4">
                <p className="text-muted mb-0">
                  <span className="font-size-16 fw-semibold text-semi-dark">
                    {t("deliveryMen_deliveryID")}
                  </span>
                  <span className="font-size-16 fw-regular text-black px-3">
                    {data.id}
                  </span>
                </p>
                <button
                  className="position-relative cursor-pointer border-0 bg-transparent"
                  onClick={() => {
                    copyToClipboard(data.id)
                  }}
                >
                  <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                  {copied && (
                    <span
                      className="position-absolute  translate-middle-x mt-1 text-success small"
                      style={{ top: "0", left: "-7px" }}
                    >
                      {t("common_copied")}
                    </span>
                  )}
                </button>
              </div>

              <div className="text-muted mb-4">
                <p className="text-semi-dark font-size-14 fw-regular mb-0">
                  {data.description}
                </p>
              </div>

              <Form
                onSubmit={e => {
                  e.preventDefault()
                  return false
                }}
              >
                <FormGroup>
                  <FormLabel htmlFor="mobileNumber" required>
                    {t("deliveryMen_mobileNumber")}
                  </FormLabel>

                  <Input
                    readOnly={!isEdit}
                    className="shadow-md"
                    id="mobileNumber"
                    name="mobileNumber"
                    type="text"
                    placeholder={t("deliveryMen_enterMobileNumber") as string}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.mobileNumber || ""}
                    invalid={
                      validation.touched.mobileNumber &&
                      validation.errors.mobileNumber
                        ? true
                        : false
                    }
                  />
                  {validation.touched.mobileNumber &&
                  validation.errors.mobileNumber ? (
                    <FormFeedback type="invalid">
                      {validation.errors.mobileNumber}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <FormLabel htmlFor="address" required>
                    {t("deliveryMen_address")}
                  </FormLabel>

                  <Input
                    readOnly={!isEdit}
                    id="address"
                    name="address"
                    className="shadow-md"
                    type="text"
                    placeholder={t("deliveryMen_enterAddress") as string}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address || ""}
                    invalid={
                      validation.touched.address && validation.errors.address
                        ? true
                        : false
                    }
                  />
                  {validation.touched.address && validation.errors.address ? (
                    <FormFeedback type="invalid">
                      {validation.errors.address}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <div className="d-flex gap-2 align-items-center mt-4">
                    <p className="text-semi-dark text-start">
                      <b>{t("common_active")}</b>
                      <span> ({t("deliveryMen_campaignInactivePeriod")})</span>
                    </p>
                    <div className="form-check form-switch mb-3">
                      <input
                        type="checkbox"
                        name="active"
                        className="form-check-input"
                        checked={validation.values.active}
                        onChange={validation.handleChange}
                        disabled={!isEdit}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  )
}

export default DeliveryManDetails
